import moment from 'moment-timezone';
import React from 'react';
import { connect } from 'react-redux';
import DatePicker from 'react-datepicker';
import { bindActionCreators } from 'redux';
import { withRouter } from "react-router-dom";
import { Alert, Button, Col, Container, Form, FormGroup, Input, Label, Modal, ModalHeader, ModalBody, ModalFooter, Row } from 'reactstrap';
import BinaryRadio from './BinaryRadio';
import CreateRecordEvent from './CreateRecordEvent';
import CreateRecordHolter from './CreateRecordHolter';
import CreateRecord12Lead from './CreateRecord12Lead';
import CreateRecordCrfQa from './CreateRecordCrfQa';
import DropdownSelection from '../data/DropDown';
import MdOverreadAssigned from './MdOverreadAssigned';
import NotAuthenticated from './NotAuthenticated';
import * as Accounts from '../store/Accounts';
import * as elements from '../data/Elements';
import * as paths from '../data/Paths';
import * as sortfilter from '../data/SortFilter';
import * as Records from '../store/Records';
import * as utility from '../data/Utility';
import './Common.css';

const viewRecordId = "viewRecord";
const viewRecordType = {
    comments: "comments",
    deviceModel: "deviceModel",
    deviceSerial: "deviceSerial",
    mdOverreadFindings: "mdOverreadFindings",
    mdRejectionReason: "mdRejectionReason",
    predominantRhythm: "predominantRhythm",
    hasAfib: "hasAfib",
    hasAflutter: "hasAflutter",
    hasAtachy: "hasAtachy",
	hasAfib30: "hasAfib30",
	hasAflutter30: "hasAflutter30",
	hasAtachy30: "hasAtachy30",
	hasAfibContinuous: "hasAfibContinuous",
	hasAflutterContinuous: "hasAflutterContinuous",
	hasAtachyContinuous: "hasAtachyContinuous",
	afibLongestDuration: "afibLongestDuration",
	aflutterLongestDuration: "aflutterLongestDuration",
	atachyLongestDuration: "atachyLongestDuration",
	isMdNotification: "isMdNotification",
	isAnalyzable: "isAnalyzable",
	totalDuration: "totalDuration",
	analyzableDuration: "analyzableDuration",
    receiveDateTime: "receiveDateTime",
    receiveDate: "receiveDate",
    receiveTime: "receiveTime",
    recordDateTime: "recordDateTime",
    recordDate: "recordDate",
    recordTime: "recordTime",
    timeZoneOffsetMinutes: "timeZoneOffsetMinutes",
	unknown: "Unknown",
};

const blankDropdown = '---';


class ViewRecord extends React.Component {
    constructor(props) {
        super(props);

		const userName = utility.propCheck(this.props.accountsState.authenticatedAccount && this.props.accountsState.authenticatedAccount.userName, "");

		let arrOrdinalNumbers = (Array.from( Array(52), (_, x) => x + 1 )).map( (n) => utility.ordinalSuffixOf(n).toUpperCase() );
		arrOrdinalNumbers.unshift(blankDropdown);

		this.pdfLoading = false;

        this.state = {
			...props.location.state,
			currentScheduleOrdinal: blankDropdown,
			currentSchedulePeriod: blankDropdown,
			currentScheduleSuffix: blankDropdown,
			arrOrdinalNumbers: arrOrdinalNumbers,
			disableScheduling: false,
			isScheduled: false,
			timeZoneOffsetMinutes: 0,
			crfQnA: this.getCrfQnA(),
            dataNeedsSaving: false,
			isScheduler: false,
            error: false,
            message: "",
            password: "",
			recordHistory: null,
            receiveDate: null,
            receiveTime: null,
            recordDate: null,
            recordTime: null,
			showAfibChildren: false,
			showAflutterChildren: false,
			showAtachyChildren: false,
			showReAuthenticator: false,
			confirmedSigningReason: false,
            spinner: false,
            userName: userName,
			hoverWhyQaDisabled: false,
			lastFetchedRecordId: null,
			verified: false,
			initCount: 0,
			isInitializing: false
        };

		this.IsScheduledDiv = this.IsScheduledDiv.bind(this);
		this.IsSymptomaticDiv = this.IsSymptomaticDiv.bind(this);
		this.OverreadRelatedDiv = this.OverreadRelatedDiv.bind(this);
        this.handleSigningReason = this.handleSigningReason.bind(this);
		this.backToSelectRecords = this.backToSelectRecords.bind(this);
		this.requestSignature = this.requestSignature.bind(this);
		this.cancelSignature = this.cancelSignature.bind(this);
        this.handlePassword = this.handlePassword.bind(this);
        this.handleKeyDown = this.handleKeyDown.bind(this);
        this.handleCrfQnA = this.handleCrfQnA.bind(this);
        this.handleValue = this.handleValue.bind(this);
        this.handleSave = this.handleSave.bind(this);
        this.initialize = this.initialize.bind(this);
    }

    initialize(prevProps) {
		console.log(`initialize ` + this.state.initCount++);

		if (this.state.isInitializing) {
			console.log("already running, leave");
			return;
		}
		else {
			console.log("not running, proceed");
			this.state.isInitializing = true;
        }

		const accountsState = this.props.accountsState;
        const authenticated = Accounts.authenticatedAllRoles(accountsState);
        var recordIdChanged = true;
        const recordId = this.state.recordId;
        const serviceType = this.state.serviceType;
        const studyId = this.state.studyId;

		if ( this.props.accountsState.authenticatedAccount == null || ! authenticated ) {
			return;
		}

		recordIdChanged = (this.state.lastFetchedRecordId !== recordId ) && ! this.props.recordsState.fetching;

        if ( (Accounts.authenticatedPrevProps(prevProps, authenticated, accountsState.fetching) && accountsState.allPhysicians == null)
				|| recordIdChanged
				) {

			console.log(`inside`);

            this.props.recordsDispatch.reset();
            this.setState({
                dataNeedsSaving: false
            });

			const recordsState = this.props.recordsState;
			const recGeneral = recordsState && recordsState.record && recordsState.record.record;
			let study = recGeneral && recGeneral.patient && recGeneral.patient.studySite && recGeneral.patient.studySite.study;
			if ( study ) {

				let allCompSchedules = study.allCompSchedules;
				if ( allCompSchedules ) {
					if ( typeof allCompSchedules === 'string' || allCompSchedules instanceof String ) {
						allCompSchedules = JSON.parse(allCompSchedules);
					}
					this.setState({ currentSchedulePeriod: allCompSchedules[recGeneral.serviceType] });
				}
			}


            (async () => {
                if (serviceType === Records.recordServiceTypes.event) {
                    await this.props.recordsDispatch.getEvent(recordId, studyId);
					if ( this.props.recordsState.record === null ) {
						return;
					}
					const recGeneral = this.props.recordsState.record.record;
					const isScheduler = recGeneral.scheduleOrdinal || recGeneral.schedulePeriod || recGeneral.scheduleSuffix;
					this.setState({
						crfQnA: this.getCrfQnA(),
						isScheduler: isScheduler,
						currentScheduleOrdinal: recGeneral.scheduleOrdinal ? recGeneral.scheduleOrdinal : blankDropdown,
						currentScheduleSuffix: recGeneral.scheduleSuffix ? recGeneral.scheduleSuffix : blankDropdown,
						isScheduled: recGeneral.isScheduled,
					});
                }
                else if (serviceType === Records.recordServiceTypes.holter) {
                    await this.props.recordsDispatch.getHolter(recordId, studyId);
					if ( this.props.recordsState.record === null ) {
						return;
					}
					const recGeneral = this.props.recordsState.record.record;
					const isScheduler = recGeneral.scheduleOrdinal || recGeneral.schedulePeriod || recGeneral.scheduleSuffix;
					this.setState({
						crfQnA: this.getCrfQnA(),
						isScheduler: isScheduler,
						currentScheduleOrdinal: recGeneral.scheduleOrdinal ? recGeneral.scheduleOrdinal : blankDropdown,
						currentScheduleSuffix: recGeneral.scheduleSuffix ? recGeneral.scheduleSuffix : blankDropdown,
						isScheduled: recGeneral.isScheduled,
					});
                }
                else if (serviceType === Records.recordServiceTypes.twelveLead) {
                    await this.props.recordsDispatch.get12Lead(recordId, studyId);
					if ( this.props.recordsState.record === null ) {
						return;
					}
					const recGeneral = this.props.recordsState.record.record;
					const isScheduler = recGeneral.scheduleOrdinal || recGeneral.schedulePeriod || recGeneral.scheduleSuffix;
					this.setState({
						crfQnA: this.getCrfQnA(),
						isScheduler: isScheduler,
						currentScheduleOrdinal: recGeneral.scheduleOrdinal ? recGeneral.scheduleOrdinal : blankDropdown,
						currentScheduleSuffix: recGeneral.scheduleSuffix ? recGeneral.scheduleSuffix : blankDropdown,
						isScheduled: recGeneral.isScheduled,
					});
				} else {
					console.log(`Error:  bad serviceType  = '${serviceType}'`);
					Accounts.checkAuthenticated(this.props.accountsState.authenticated, this.props.accountsDispatch);
                }
            })().then(() => {
				const recGeneral = this.props.recordsState.record && this.props.recordsState.record.record;
				if ( recGeneral ) {
					let tzOffset = recGeneral.timeZoneOffsetMinutes;
					if ( Math.abs(tzOffset) <= 16 ) {
						tzOffset *= 60;
					}

					this.setState({
						timeZoneOffsetMinutes: tzOffset,
					});
				}

				(async () => {
					await this.populateSchedulingDropdowns();
					await this.props.recordsDispatch.getReport(recordId, studyId);
					this.adjustVisibiltyOfQuestions();
					this.setState({ lastFetchedRecordId: recordId });

				})().then(() => {
					this.getPatientRecordHistory();
				});
            });
        }
    }


    componentDidMount() {
        Accounts.checkAuthenticated(this.props.accountsState.authenticated, this.props.accountsDispatch);
        this.initialize(null);
    }

    componentDidUpdate(prevProps) {
        this.initialize(prevProps);
    }

    componentWillUnmount() {
        this.props.recordsDispatch.disposeReport();
    }

	getPatientRecordHistory() {
		if ( ! this.props.recordsState.fetching ) {
			if ( (this.state.recordHistory === null) && (this.props.recordsState.record !== null && this.props.recordsState.record !== undefined) ) {
				(async () => {
					const rec = this.props.recordsState.record;
					const patientId = rec.record.patient.id;
					await this.props.recordsDispatch.GetAllRecordListByPatient(patientId);
				})().then(() => {
					const recordHistory = this.props.recordsState.recordHistory;
					this.setState({ recordHistory: recordHistory })
				});
			}
		}
	}

	getCrfQnA() {
        var crfQnA = this.props.recordsState && this.props.recordsState.record && this.props.recordsState.record.record && this.props.recordsState.record.record.crfQnA;
		if ( crfQnA == null || ((typeof crfQnA === 'string' || crfQnA instanceof String) && crfQnA.length === 0 ) ) {
			var pat = this.props.recordsState.record && this.props.recordsState.record.record && this.props.recordsState.record.record.patient;
			var stud = pat && pat.studySite && pat.studySite.study;

			/* only use an empty set of CRF question from the study if we are passed the service type through the properties as a new Create Record */
			const serviceType = this.props.serviceType;

			switch ( serviceType ) {
				case Records.recordServiceTypes.event:
					crfQnA = stud && stud.crfQnaEvent;
					break;
				case Records.recordServiceTypes.holter:
					crfQnA = stud && stud.crfQnaHolter;
					break;
				case Records.recordServiceTypes.twelveLead:
					crfQnA = stud && stud.crfQna12Lead;
					break;
				default:
					break;
			}
		}

		if ( typeof crfQnA === 'string' || crfQnA instanceof String ) {
			crfQnA = JSON.parse(crfQnA);
		}
		return crfQnA;
	}

	isCrfUnanswered() {
		let cntUnanswered = 0;
		const recGeneral = this.props.recordsState.record && this.props.recordsState.record.record;
		let crfQnA = this.state.crfQnA;
		if ( ! crfQnA ) {
			crfQnA = recGeneral && JSON.parse(recGeneral.crfQnA);
		}
		if ( ! crfQnA ) {
			crfQnA = this.getCrfQnA();
		}
		if ( crfQnA ) {
			cntUnanswered = crfQnA.reduce( function (accumulator, c) { return accumulator + ((c.answerText) ? 0 : 1); }, 0);
		}

		return (cntUnanswered !== 0);
	}

	handleCrfQnA( serviceType, crfQnA ) {
		this.setState({ crfQnA: crfQnA });
	}

	IsScheduledDiv = (props) => {

		const ScheduleDiv = (props) => {
			if ( ! props.value ) {
				return null;
			}
			const classNameInput = "scheduler";
			let arrSuffix = [blankDropdown, 'BASELINE', 'DISCHARGE', 'POST PROCEDURE', 'PRE PROCEDURE'];

			return (
				<div className="gap-bottom">
					Scheduled: 
					&nbsp;
					<DropdownSelection
							disabled={props.disabled || this.state.disableScheduling}
							id="dropdown_OrdinalNumbers"
							isCheckboxes={false}
							className={classNameInput}
							values={[this.state.currentScheduleOrdinal]}
							selections={this.state.arrOrdinalNumbers}
							onSelect={this.handleDropdownOrdinalNumber.bind(this)} />
					&nbsp;
					<div className="boxPeriod">
					of {this.state.currentSchedulePeriod}
					</div>
					&nbsp;
					<DropdownSelection
							disabled={props.disabled || this.state.disableScheduling}
							id="dropdown_Suffix"
							isCheckboxes={false}
							className={classNameInput}
							values={[this.state.currentScheduleSuffix]}
							selections={arrSuffix}
							onSelect={this.handleDropdownSuffix.bind(this)} />
				</div>
				);
		};

		return (
			<div>
				<BinaryRadio
						title="Is the record scheduled?"
						disabled={props.disabled}
						name="scheduledRadio"
						onChangeFalse={this.handleIsScheduled.bind(this, false)}
						onChangeTrue={this.handleIsScheduled.bind(this, true)}
						value={this.state.isScheduled} />
				<ScheduleDiv
						disabled={props.disabled}
						value={this.state.isScheduled} />
			</div>
		);
	}

	IsSymptomaticDiv = (props) => {
		return (
			<BinaryRadio
				title="Is the record symptomatic?"
				disabled={props.disabled}
				name="symptomaticRadio"
				onChangeFalse={this.handleIsSymptomatic.bind(this, false)}
				onChangeTrue={this.handleIsSymptomatic.bind(this, true)}
				value={props.recordRecord.isSymptomatic}
			/>
		);
	}


	PredominantRhythm = (props) => {
		const allRhythms = [
			viewRecordType.unknown,
			"Accelerated Idioventricular Rhythm",
			"Accelerated Junctional Rhythm",
			"Asystole",
			"Atrial Fibrillation",
			"Atrial Flutter",
			"Atrial Tachycardia",
			"Idioventricular Rhythm",
			"Junctional Escape Rhythm",
			"Junctional Tachycardia",
			"Multifocal Atrial Tachycardia",
			"Normal Sinus Rhythm",
			"Paced Rhythm",
			"Pacemaker Failure to Capture",
			"Pacemaker Failure to Pace",
			"Pacemaker Single Chamber Atrial",
			"Premature Atrial Complex",
			"Second Degree Heart Block Type I",
			"Second Degree Heart Block Type II",
			"Sinus Arrhythmia",
			"Sinus Bradycardia",
			"Sinus Tachycardia",
			"Supraventricular Tachycardia",
			"Third Degree Heart Block",
			"Ventricular Fibrillation",
			"Ventricular Tachycardia",
			"Ventricular Tachycardia Monomorphic",
			"Ventricular Tachycardia Polymorphic",
			"Ventricular Tachycardia Torsade de Pointes",
			"Wandering Atrial Pacemaker",
			"Wolff-Parkinson-White Syndrome",
		];

		const classNameInput = "scheduler";

        const record = this.props.recordsState.record.record;

		if ( record.predominantRhythm === null || record.predominantRhythm === undefined ) {
			record.predominantRhythm = viewRecordType.unknown;
		}

		if ( record.predominantRhythm === null || record.predominantRhythm === undefined ) {
			record.predominantRhythm = '';
		}

		const accountsState = this.props.accountsState;
		const authenticatedRole = accountsState.authenticatedAccount.role;
        const isPhysicianRole = (authenticatedRole === Accounts.accountRoles.Physician);

		return (
			<div className="gap gap-bottom">
				Predominant Rhythm: 
				&nbsp;
				<DropdownSelection disabled={isPhysicianRole || props.disabled} id="dropdown_PredominantRhythm" isCheckboxes={false} className={classNameInput} values={[record.predominantRhythm]} selections={allRhythms} onSelect={(e) => this.handleValue(e, viewRecordType.predominantRhythm)} />
			</div>
			);

	}

	HmInput = (props) => {
		return elements.getFormGroup(props.title, false, elements.getInput(props.name, props.disabled, (e) => this.handleValue(e.target.value, props.varname), this.handleKeyDown, elements.inputTypes.hm, props.value));
	};

	HmsInput = (props) => {
		return elements.getFormGroup(props.title, false, elements.getInput(props.name, props.disabled, (e) => this.handleValue(e.target.value, props.varname), this.handleKeyDown, elements.inputTypes.hms, props.value));
	};

	NumericInput = (props) => {
		return elements.getFormGroup(props.title, false, elements.getInput(props.name, props.disabled, (e) => this.handleValue(e.target.value, props.varname), this.handleKeyDown, elements.inputTypes.text, props.value));
	};

	IsAnalyzable = (props) => {
		return (
			<BinaryRadio
				title="Is the record analyzable?"
				disabled={props.disabled}
				name="radio_Analyzable"
				onChangeFalse={this.handleYesNo.bind(this,viewRecordType.isAnalyzable,false)}
				onChangeTrue={this.handleYesNo.bind(this,viewRecordType.isAnalyzable,true)}
				value={props.isAnalyzable}
			/>
		);
	}

	RecordQuestions = (props) => {
        const record = props.record;
		const recGeneral = record.record;
        const serviceType = props.serviceType;
		const isEvent  = serviceType === Records.recordServiceTypes.event;
		const isHolter = serviceType === Records.recordServiceTypes.holter;
		const is12Lead = serviceType === Records.recordServiceTypes.twelveLead;

		return (
			<div>

			{isHolter && <this.HmInput disabled={props.disabled} name="radio_TotalDuration" varname={viewRecordType.totalDuration} title="Total Duration: " value={record.totalDuration} /> }
			{isHolter && <this.HmInput disabled={props.disabled} name="radio_AnalyzableDuration" varname={viewRecordType.analyzableDuration} title="Analyzable Duration: " value={record.analyzableDuration} /> }

			<BinaryRadio disabled={props.disabled} name="radio_Afib" onChangeFalse={this.handleYesNo.bind(this,viewRecordType.hasAfib,false)} onChangeTrue={this.handleYesNo.bind(this,viewRecordType.hasAfib,true)} title="Afib?" value={recGeneral.hasAfib} />

			{this.state.showAfibChildren &&
				<div className="indented" >
				{isEvent  && <BinaryRadio disabled={props.disabled} name="radio_hasAfib30" onChangeFalse={this.handleYesNo.bind(this,viewRecordType.hasAfib30,false)} onChangeTrue={this.handleYesNo.bind(this,viewRecordType.hasAfib30,true)} title="Has Afib of 30 seconds?" value={record.hasAfib30} /> }
				{isHolter && <this.HmsInput disabled={props.disabled} name="radio_AfibLongestDuration" varname={viewRecordType.afibLongestDuration} title="Afib longest duration: " value={record.afibLongestDuration} /> }
				{is12Lead && <BinaryRadio disabled={props.disabled} name="radio_hasAfib30" onChangeFalse={this.handleYesNo.bind(this,viewRecordType.hasAfibContinuous,false)} onChangeTrue={this.handleYesNo.bind(this,viewRecordType.hasAfibContinuous,true)} title="Afib continuous?" value={record.hasAfibContinuous} /> }
				</div>
			}

			<BinaryRadio disabled={props.disabled} name="radio_Aflutter" onChangeFalse={this.handleYesNo.bind(this,viewRecordType.hasAflutter,false)} onChangeTrue={this.handleYesNo.bind(this,viewRecordType.hasAflutter,true)} title="Aflutter?" value={recGeneral.hasAflutter} />
			{this.state.showAflutterChildren &&
				<div className="indented" >
				{isEvent  && <BinaryRadio disabled={props.disabled} name="radio_hasAflutter30" onChangeFalse={this.handleYesNo.bind(this,viewRecordType.hasAflutter30,false)} onChangeTrue={this.handleYesNo.bind(this,viewRecordType.hasAflutter30,true)} title="Has Aflutter of 30 seconds?" value={record.hasAflutter30} /> }
				{isHolter && <this.HmsInput disabled={props.disabled} name="radio_AflutterLongestDuration" varname={viewRecordType.aflutterLongestDuration} title="Aflutter longest duration: " value={record.aflutterLongestDuration} /> }
				{is12Lead && <BinaryRadio disabled={props.disabled} name="radio_hasafluttercon" onChangeFalse={this.handleYesNo.bind(this,viewRecordType.hasAflutterContinuous,false)} onChangeTrue={this.handleYesNo.bind(this,viewRecordType.hasAflutterContinuous,true)} title="Aflutter continuous?" value={record.hasAflutterContinuous} /> }
				</div>
			}

			<BinaryRadio disabled={props.disabled} name="radio_Atachy" onChangeFalse={this.handleYesNo.bind(this,viewRecordType.hasAtachy,false)} onChangeTrue={this.handleYesNo.bind(this,viewRecordType.hasAtachy,true)} title="Atachy?" value={recGeneral.hasAtachy} />
			{this.state.showAtachyChildren &&
				<div className="indented" >
				{isEvent  && <BinaryRadio disabled={props.disabled} name="radio_hasAtachy30" onChangeFalse={this.handleYesNo.bind(this,viewRecordType.hasAtachy30,false)} onChangeTrue={this.handleYesNo.bind(this,viewRecordType.hasAtachy30,true)} title="Has Atachy of 30 seconds?" value={record.hasAtachy30} /> }
				{isHolter && <this.HmsInput disabled={props.disabled} name="radio_atachyLongestDuration" varname={viewRecordType.atachyLongestDuration} title="Atachy longest duration: " value={record.atachyLongestDuration} /> }
				{is12Lead && <BinaryRadio disabled={props.disabled} name="radio_hasAtachyCont" onChangeFalse={this.handleYesNo.bind(this,viewRecordType.hasAtachyContinuous,false)} onChangeTrue={this.handleYesNo.bind(this,viewRecordType.hasAtachyContinuous,true)} title="Atachy continuous?" value={record.hasAtachyContinuous} /> }
				</div>
			}

			<BinaryRadio disabled={props.disabled} name="radio_MdNotification" onChangeFalse={this.handleYesNo.bind(this,viewRecordType.isMdNotification,false)} onChangeTrue={this.handleYesNo.bind(this,viewRecordType.isMdNotification,true)} title="MD Notification?" value={recGeneral.isMdNotification} />
			</div>
		);
	}


	OverreadRelatedDiv = (props) => {
		if ( props.hidden ) {
			return null;
		}

		const tooltipStyle = {
			display: props.disableQa && this.state.hoverWhyQaDisabled ? 'block' : 'none'
		}

		const reasonsWhyQaDisabled = props.reasonsWhyQaDisabled.map( (r,idx) => <li key={"qd_"+idx}> {r} </li> );

		return (
			<div>
				<hr />
				<Row>
					<Col>
						<BinaryRadio
								title="Is MD overread required?"
								disabled={props.disableMdOverreadRequired}
								hideNotAnswered
								name="overreadRequiredRadio"
								onChangeFalse={this.handleIsMdOverreadRequired.bind(this, false)}
								onChangeTrue={this.handleIsMdOverreadRequired.bind(this, true)}
								value={props.recordRecord.isMdOverreadRequired}
								/>
						<MdOverreadAssigned disabled={props.disableMdOverreadAssigned} />
						<BinaryRadio
								title="Has MD overread been performed?"
								disabled={true}
								hideNotAnswered
								name="overreadCompletedRadio"
								value={props.recordRecord.isMdOverreadComplete}
								/>
					</Col>
				</Row>
				{props.displayRejectionReason &&
					<div>
						<Row>
							<Col>
							Rejection Reason:
							<Input
									className="input"
									disabled={true}
									id="mdRejectionReason"
									type="textarea"
									value={props.recordRecord.mdRejectionReason}
								/>
							</Col>
						</Row>
					</div>
				}
				<hr />
				<Row>
					<Col>
						<BinaryRadio
								title="Is quality assurance (QA) required?"
								disabled={props.disableQaRequired}
								hideNotAnswered
								name="qaRequiredRadio"
								onChangeFalse={this.handleIsQaRequired.bind(this, false)}
								onChangeTrue={this.handleIsQaRequired.bind(this, true)}
								value={props.recordRecord.isQaRequired}
							/>
					</Col>
				</Row>
				<Row>
					<Col>
						<div onMouseOver={this.handleMouseInForWhyQaDisabled.bind(this)} onMouseOut={this.handleMouseOutForWhyQaDisabled.bind(this)}>
							{props.disableQa 
								? <BinaryRadio
										title="Is the record QA/complete?"
										disabled={props.disableQaControl}
										hideNotAnswered
										labelFalse="No, only HCS users can access the record."
										labelTrue="Yes, the record is available to all appropriate users on the portal."
										name="qaRadio"
										onChangeFalse={this.handleIsQaComplete.bind(this, false)}
										//onChangeTrue={this.handleIsQaComplete.bind(this, true)}
										value={props.recordRecord.isQaComplete}
								/>
								: <BinaryRadio
									title="Is the record QA/complete?"
									disabled={props.disableQa}
									hideNotAnswered
									labelFalse="No, only HCS users can access the record."
									labelTrue="Yes, the record is available to all appropriate users on the portal."
									name="qaRadio"
									onChangeFalse={this.handleIsQaComplete.bind(this, false)}
									onChangeTrue={this.handleIsQaComplete.bind(this, true)}
									value={props.recordRecord.isQaComplete}
								/>
							}
						</div>
					</Col>
					<Col>
						<div className="whyQaDisabled" style={tooltipStyle}>
							<h4> Why is QA/complete still disabled? </h4>
							<ul>
								{reasonsWhyQaDisabled}
							</ul>
						</div>
					</Col>
				</Row>
			</div>
		);
	}

	handleMouseInForWhyQaDisabled(e) {
		this.setState({ hoverWhyQaDisabled: true });
	}

	handleMouseOutForWhyQaDisabled(e) {
		this.setState({ hoverWhyQaDisabled: false });
	}


	ColumnHeader = (props) => {
		sortfilter.filterAssociation[props.recordKey] = props.label;
		let val = '';
		return <sortfilter.ColHeader doGrid={props.doGrid} value={val} showFilter={false} className={props.className} label={props.label} />
	};

	DisplayPatientRecordHistory = (props) => {
        const accountsState = this.props.accountsState;
        if (!Accounts.authenticatedAllRoles(accountsState)) {
            return (
                <NotAuthenticated />
            );
        }

		if ( ! props.show ) {
			return null;
		}

        let recordList = null;

        const records = this.state.recordHistory;
        if (records != null && records.map != null) {
            var rowNum = 1;

			let tzOffset = this.state.timeZoneOffsetMinutes;
			if ( Math.abs(tzOffset) <= 16 ) {
				tzOffset *= 60;
			}
			let rList = [...records].map( (record,idx) => {
				return ({ ...record,
					recordDateTime: utility.formatDisplayDateTime(moment(record.recordDateTime).add(tzOffset,'m')),
					mdOverreadDateTime: utility.formatDisplayDateTime(moment(record.mdOverreadDateTime).add(tzOffset,'m')),
				});
            });

			const patCode = this.props.recordsState.record.record.patient.code;
			const currentSortingColumn = "recordDateTime";
			let currentSortDirection = { recordDateTime: "down" };
			const currentFilters = { "Patient": patCode };
			rList = sortfilter.filterData( rList, currentFilters );

            recordList = [...rList].sort( sortfilter.sortingDetails(currentSortingColumn,currentSortDirection).fn ).map(record => {
                return (
                    <Row key={record.id} id={record.id} onClick={null} className="recordHistoryTableBody">
                        <Col className="col-1 centerOnly"> {rowNum++}</Col>
                        <Col className="      centerOnly"> {record.recordDateTime}</Col>
                        <Col className="col-1 centerOnly"> {record.serviceType}</Col>
                        <Col className="                "> {record.predominantRhythm}</Col>
						<Col className="                "> {record.mdOverreadFindings}</Col>
						<Col className="      centerOnly"> {record.mdOverreadDateTime}</Col>
                    </Row>
                );
            });
        }

		return (
            <div className="gap">
                <Label for="recordHistory">
				Patient Record History:
                </Label>
                <Container fluid className="tableRecordHistory">
					<Row id="recordHistoryTableHead">
						<this.ColumnHeader doGrid={true} className="col-1" label="#" />
						<this.ColumnHeader doGrid={true} className="     " label="Record DateTime" />
						<this.ColumnHeader doGrid={true} className="col-1" label="Service Type" />
						<this.ColumnHeader doGrid={true} className="     " label="Predominant Rhythm" />
						<this.ColumnHeader doGrid={true} className="     " label="Findings" />
						<this.ColumnHeader doGrid={true} className="     " label="MD Date" />
					</Row>
					{recordList}
                </Container>
			</div>
			);
	}

    getMetadataDiv( recGeneral, isDisabled ) {

		if ( recGeneral.comments === null || recGeneral.comments === undefined ) {
			recGeneral.comments = '';
		}

		let tzOffset = this.state.timeZoneOffsetMinutes;
		if ( Math.abs(tzOffset) <= 16 ) {
			tzOffset *= 60;
		}

		const recordDateTimePicker = (val,type,isDisabled) => {
			if ( ! moment(val).isValid() ) {
				val = moment().utc().format("YYYY-MM-DDTHH:mm:ss");
			}
			return (
					<DatePicker
						selected={new Date(moment(val).add(tzOffset,'m').format())}
						onChange={(datestr) => this.handleValue(datestr, type)}
						timeInputLabel="Time:"
						dateFormat="MM/dd/yyyy HH:mm:ss"
						timeFormat="HH:mm:ss"
						placeholderText="Type or Click to select a date"
						showTimeInput
						peekNextMonth
						showMonthDropdown
						showYearDropdown
						dropdownMode="select"
						closeOnScroll={true}
						disabled={isDisabled}
					/>
			);
		};

        const deviceModel = elements.getFormGroup("Device Model", true, elements.getInput("deviceModelInput", isDisabled, (e) => this.handleValue(e.target.value, viewRecordType.deviceModel), this.handleKeyDown, elements.inputTypes.text, recGeneral.deviceModel));
        const deviceSerial = elements.getFormGroup("Device Serial Number", true, elements.getInput("deviceSerialInput", isDisabled, (e) => this.handleValue(e.target.value, viewRecordType.deviceSerial), this.handleKeyDown, elements.inputTypes.text, recGeneral.deviceSerial));
        const recordDateTime = elements.getFormGroup(`Record DateTime (Patient's Time)`, false, recordDateTimePicker(recGeneral.recordDateTime,viewRecordType.recordDateTime,isDisabled), null );
        const receiveDateTime = elements.getFormGroup(`Receive DateTime (Patient's Time)`, false, recordDateTimePicker(recGeneral.receiveDateTime,viewRecordType.receiveDateTime,isDisabled), null );
        const timeZoneOffsetMinutes = elements.getFormGroup("Time Zone Offset (difference between UTC and local time)", true, elements.getInputGroup(elements.getInput("timeZoneOffsetMinutesInput", isDisabled, (e) => this.handleValue(e.target.value, viewRecordType.timeZoneOffsetMinutes), this.handleKeyDown, elements.inputTypes.text, this.state.timeZoneOffsetMinutes), ((Math.abs(this.state.timeZoneOffsetMinutes) <= 16) || isNaN(this.state.timeZoneOffsetMinutes)) ? "Hours" : "Minutes"));
		const comments = elements.getFormGroup("Comments", true, elements.getInput("comments", isDisabled, (e) => this.handleValue(e.target.value, viewRecordType.comments), this.handleKeyDown, elements.inputTypes.textarea, recGeneral.comments));

        return (
            <Container className="group-border" fluid>
                <h4 className="center">
                    Metadata
                </h4>
                <Row>
                    <Col>
						{recordDateTime}
						{receiveDateTime}
						{timeZoneOffsetMinutes}
						{deviceModel}
						{deviceSerial}
						{comments}
                    </Col>
                </Row>
            </Container>
        );
    }

	requestSignature() {
		this.setState({
			confirmedSigningReason: false,
			showReAuthenticator: true,
            error: false,
			message: ""
		});
	}
	
	cancelSignature() {
		this.setState({
			showReAuthenticator: false,
            error: false,
			message: ""
		});
	}

	handlePassword(e) {
        this.setState({
            password: e.target.value
        });
	}

    handleSigningReason(arrChosen) {
		if ( arrChosen[0] === blankDropdown ) {
			this.setState({ confirmedSigningReason: false });
		} else {
			this.setState({ confirmedSigningReason: true });
		}
	}

    handleReAuthenticationRequest() {
        if ( ! this.state.confirmedSigningReason ) {
			this.setState({
				error: true,
				message: "You must select the signing reason before continuing.",
			});
			return;
		}

        if (this.state.clearCallback != null) {
            this.state.clearCallback();
        }
        this.setState({
            error: false,
            message: ""
        });

        const userName = this.state.userName;
        const password = this.state.password;
        if (userName === "" ||
            password === "") {
            this.setState({
                error: true,
                message: this.props.localizerState.badInputError
            });
        }
        else {
			var message = "";

            this.setState({
                spinner: true
            });
            (async () => {
                message = await this.props.accountsDispatch.signIn(userName, password, "No captcha for doc reauthentication", false);
            })().then(() => {
                if ( message === '' ) {
					this.setState({ showReAuthenticator: false });
					this.handleIsMdOverreadComplete(true);
				} else {
                    this.setState({
                        error: true,
						verified: false,
                        message: message,
						spinner: false
                    });
                }
            });
        }
    }


    getOverreadDiv(recGeneral, isPhysicianRole) {
        const displayElectronicSignature = (
            !recGeneral.isMdOverreadComplete &&
            isPhysicianRole
        );
        var mdOverreadFindings = recGeneral.mdOverreadFindings;
        const overreadDisabled = (
            recGeneral.isMdOverreadComplete ||
            !isPhysicianRole
        );

        if (mdOverreadFindings == null) {
            mdOverreadFindings = "";
        }

		const ENABLE_DEV400_QUICK_TYPER = true;
        const password = this.props.localizerState.password;
        const signIn = this.props.localizerState.signIn;
        const userName = this.props.localizerState.userName;
		const myUserName = this.state.userName;
        const message = this.state.message;
        const displayMessage = message !== "";
        const alertColor = this.state.error ? "danger" : "primary";

		if ( recGeneral.mdRejectionReason === null ) {
			recGeneral.mdRejectionReason = '';
		} 

		const classNameInput = "scheduler";
		let arrSigningReasons = ["I am the author of the overread."];
		arrSigningReasons.unshift(blankDropdown);

        return (
            <div className="gap">
                <Label for="overreadInput">
                    MD Overread:
                </Label>
				{
				( ENABLE_DEV400_QUICK_TYPER ) ?
					<div>
					<Input className="input" disabled={overreadDisabled} id="overreadInput" onChange={(e) => this.handleValue(e.target.value, viewRecordType.mdOverreadFindings)} style={{ height: "20vh" }} type="textarea" value={mdOverreadFindings} placeholder={ (overreadDisabled) ? "" : "Type in here or press the buttons below"} />
					<this.MdQuickTyper disabled={overreadDisabled} />
					</div>
				:
					<Input className="input" disabled={overreadDisabled} id="overreadInput" onChange={(e) => this.handleValue(e.target.value, viewRecordType.mdOverreadFindings)} style={{ height: "20vh" }} type="textarea" value={mdOverreadFindings} />
				}
                {displayElectronicSignature && (
					<div>
						<div className="button-gap">
							<Button className="button" onClick={this.requestSignature}>Electronic Signature</Button>
						</div>
						<div className="button-gap">
							<hr />
						</div>
						<div className="gap">
							<Label for="mdRejectionReason">
								Rejection Reason: 
							</Label>
							<Input className="input" disabled={false} id="mdRejectionReason" onChange={(e) => this.handleValue(e.target.value, viewRecordType.mdRejectionReason)} style={{ height: "10vh" }} type="textarea" value={recGeneral.mdRejectionReason} />
							<div className="button-gap">
								<Button className="button" onClick={this.handleRejectMdOverread.bind(this)}>Submit Rejection</Button>
							</div>
						</div>
                    </div>
                )}

				<Modal isOpen={this.state.showReAuthenticator} toggle={this.cancelSignature} className="gap">
					<ModalHeader toggle={this.cancelSignature}> You must re-enter your password to continue </ModalHeader>
						<ModalBody>
							{displayMessage && <Alert color={alertColor}>{message}</Alert>}
							<Form>
								<FormGroup>
									<Label for="userNameInput">{userName}</Label>
									<Input className="input" disabled={true} id="userNameInput" onKeyDown={this.handleKeyDown} title={userName} value={myUserName} />
								</FormGroup>
								<div>
									<Label for="passwordInput">{password}</Label>
									<Input className="input" id="passwordInput" onChange={this.handlePassword} onKeyDown={this.handleKeyDown} title={password} type="password"/>
								</div>
								<div className="gap">
									Signing Reason: &nbsp;
									<DropdownSelection id="dropdown_SigningReason" isCheckboxes={false} className={classNameInput} values={[blankDropdown]} selections={arrSigningReasons} onSelect={(e) => this.handleSigningReason(e)} />
								</div>
								<div className="button-gap">
									{this.state.spinner && <div className="spinner-border spinner-border-sm"></div>}
									<FormGroup />
								</div>
							</Form>
						</ModalBody>
					<ModalFooter>
						<Button color="primary" className="button" onClick={this.handleReAuthenticationRequest.bind(this)}> {signIn} </Button>{' '}
						<Button color="secondary" onClick={this.cancelSignature}>Cancel</Button>
					</ModalFooter>
				</Modal>

            </div>
        );
    }

	getUploadDiv(isAdministratorRole, isHcsRole, disableUploadReport, isMdOverreadComplete, isQaComplete) {
        if (!isHcsRole) {
            return null;
        }

		const disabled = (
			isQaComplete ||
			disableUploadReport ||
			(isMdOverreadComplete &&
				!isAdministratorRole)
		);
        const fileInput = "fileInput";
        const upload = "Upload Report";

        return (
            <div>
                <Input disabled={disabled} hidden id={fileInput} onChange={this.upload.bind(this, fileInput)} type="file" /> <Label className="file-upload" for={fileInput} title={upload}>{upload}</Label>
            </div>
        );
    }

    handleKeyDown(e) {
        if (e.key === 'Enter') {
            this.handleSave();
        }
    }

	MdQuickTyper = (props) => {
   
		const arrRhythm = [
			"Sinus Rhythm",
			"Sinus bradycardia",
			"Sinus tachycardia",
			"Sinus pauses",
			"PACs",
			"Atrial tachycardia",
			"Atrial fibrillation",
			"Atrial flutter",
			"Unifocal PVCs",
			"Multifocal PVCs",
			"Paired PVCs",
			"Junctional rhythm",
			"Supraventricular tachycardia",
			"Accelerated idioventricular rhythm",
			"Ventricular tachycardia",
			"Wide complex tachycardia",
			"Atrial pacing",
			"A-V pacing",
			"Ventricular pacing",
			]; 

		const arrConductionAbnormalities = [
			"First Degree AV block",
			"2 Degree AVB, Mobitz type 2",
			"Complete heart block",
			"WPW",
			"RBBB",
			"LBBB",
			"IRBBB",
			"ILBBB",
			"IVCD",
			"LA hemiblock",
			"LP hemiblock",
			"2 degree AVB Wenckebach",
			"2:1 AV block",
			"High degree AV block",
		];

		const arrMorphologyAbnormalities = [
			"RA abnormality",
			"LA abnormality",
			"RV hypertrophy",
			"LV hypertrophy",
			"ST-T wave abnormalities",
			"Evidence of Prior Myocardial Infarction",
			"Low voltage",
			"Left axis deviation",
			"Right axis deviation",
		];

		if ( props.disabled ) {
			return <div> </div>;
		}

		return (
				<div>
				<h3 style={{textAlign: "center"}}> Quick Typer </h3>
				<Row>
				<Col>
					<div  style={{textAlign: "center"}}> Rhythm </div>
					<div className="quick-typer-3col" >
					{
						arrRhythm.map( (item) => { return ( <div key={"r_"+item} onClick={() => this.handleQuickTyper(item)}> {item} </div> ); })
					}
					</div>
				</Col>
				<Col>
					<div  style={{textAlign: "center"}}> Conduction Abnormalities </div>
					<div className="quick-typer-3col" >
					{
						arrConductionAbnormalities.map( (item) => { return ( <div key={"c_"+item} onClick={() => this.handleQuickTyper(item)}> {item} </div> ); })
					}
					</div>
				</Col>
				<Col>
					<div  style={{textAlign: "center"}}> Morphology Abnormalities </div>
					<div className="quick-typer-2col" >
					{
						arrMorphologyAbnormalities.map( (item) => { return ( <div key={"m_"+item} onClick={() => this.handleQuickTyper(item)}> {item} </div> ); })
					}
					</div>
				</Col>
				</Row>
				</div>
			);
	}

	handleQuickTyper( str ) {
        const recGeneral = this.props.recordsState.record.record;
		let val = recGeneral.mdOverreadFindings;
        if ( val === null ) {
            val = "";
        }
		if ( val === '' ) {
			val += str;
		} else {
			val += ", " + str;
		}
		this.handleValue( val, viewRecordType.mdOverreadFindings );
	}


	backToSelectRecords() {
		const recordId = this.props.recordsState.record.record.id;
		this.props.history.push({
			pathname: paths.selectRecord,
			state: { selectedId: recordId }
		});
	}

    handleSave() {
		const recordsState = this.props.recordsState;
        const recGeneral = recordsState.record.record;
        const serviceType = recGeneral.serviceType;

		let tzOffset = this.state.timeZoneOffsetMinutes;
		if ( Math.abs(tzOffset) <= 16 ) {
			tzOffset *= 60;
		}
		recGeneral.timeZoneOffsetMinutes = tzOffset;

        if (serviceType === Records.recordServiceTypes.event) {
            this.props.recordsDispatch.updateEvent();
        }
        else if (serviceType === Records.recordServiceTypes.holter) {
            this.props.recordsDispatch.updateHolter();
        }
        else if (serviceType === Records.recordServiceTypes.twelveLead) {
            this.props.recordsDispatch.update12Lead();
		}
		else {
			console.log(`Error:  bad serviceType = "${serviceType}" `);
        }
        this.props.recordsDispatch.setRefresh( true );
        this.setState({
            dataNeedsSaving: false
        });
    }

    handleRejectMdOverread() {
        const recGeneral = this.props.recordsState.record.record;
        (async () => {
            await this.props.recordsDispatch.updateRecordMdRejection(recGeneral.id, recGeneral.mdRejectionReason);
        })().then(() => {
            this.props.recordsDispatch.setAll(null);
            this.props.history.push(paths.dashboard);
        });
	}

    handleIsMdOverreadComplete(isComplete) {
        if (!isComplete) {
            return;
        }

        const recGeneral = this.props.recordsState.record.record;
        recGeneral.isMdOverreadComplete = isComplete;
        (async () => {
            await this.props.recordsDispatch.updateRecordMdOverreadFindings(recGeneral.id, recGeneral.mdOverreadFindings);
        })().then(() => {
            this.props.recordsDispatch.setAll(null);
            this.props.history.push(paths.dashboard);
        });
    }

    handleIsMdOverreadRequired(isRequired) {
        const recGeneral = this.props.recordsState.record.record;
        recGeneral.isMdOverreadRequired = isRequired;
        this.props.recordsDispatch.updateRecordIsMdOverreadRequired(recGeneral.id, isRequired);
    }

    handleIsQaComplete(isComplete) {
        const recGeneral = this.props.recordsState.record.record;
        recGeneral.isQaComplete = isComplete;
        (async () => {
            await this.props.recordsDispatch.updateRecordQa(recGeneral.id, isComplete);
        })().then(() => {
			if ( isComplete ) {
				this.props.recordsDispatch.setAll(null);
				this.backToSelectRecords();
			} else {
				this.props.recordsDispatch.get12Lead(this.state.recordId, this.state.studyId);
			}
        });
    }

    handleIsQaRequired(isRequired) {
        const recGeneral = this.props.recordsState.record.record;
        recGeneral.isQaRequired = isRequired;
        this.props.recordsDispatch.updateRecordIsQaRequired(recGeneral.id, isRequired);
    }

	async populateSchedulingDropdowns() {
		const recordsState = this.props.recordsState;
        const recGeneral = recordsState && recordsState.record && recordsState.record.record;
		let study = recGeneral && recGeneral.patient && recGeneral.patient.studySite && recGeneral.patient.studySite.study;
		if ( study ) {

			let allCompSchedules = study.allCompSchedules;
			if ( allCompSchedules ) {
				if ( typeof allCompSchedules === 'string' || allCompSchedules instanceof String ) {
					allCompSchedules = JSON.parse(allCompSchedules);
				}
				this.setState({ currentSchedulePeriod: allCompSchedules[recGeneral.serviceType] });
			}


			(async () => {

				this.setState({ disableScheduling: true });	/* disable the dropdowns until we initialize them with proper values */
				await this.props.recordsDispatch.getRecentScheduleOrdinalPeriod(recGeneral.patient.id, recGeneral.serviceType);

			})().then(() => {

				let existingOrdinal = this.props.recordsState.lastScheduleOrdinal && this.props.recordsState.lastScheduleOrdinal.split(',');

				let arrOrdinalNumbers = [];
				if ( ! existingOrdinal || existingOrdinal === blankDropdown ) {
					existingOrdinal = blankDropdown;
					arrOrdinalNumbers = (Array.from( Array(52), (_, x) => x + 1 )).map( (n) => utility.ordinalSuffixOf(n).toUpperCase() );
					arrOrdinalNumbers.unshift(blankDropdown);
				} else {
					arrOrdinalNumbers = [ blankDropdown ];
					for ( let i = 1 ; i < 52 ; i++ ) {
						const ord = utility.ordinalSuffixOf(i).toUpperCase();
						if ( ! existingOrdinal.includes(ord) ) {
							/* only add ordinals to the dropdown options that come after the one returned in existingOrdinal */
							arrOrdinalNumbers.push(ord);
						}
					}
				}

				let thisOrdinal = blankDropdown;
				if ( recGeneral.scheduleOrdinal && (/^\d*[A-Za-z].*/.test(recGeneral.scheduleOrdinal)) ) {
					thisOrdinal = recGeneral.scheduleOrdinal;
				}

				this.setState({
					currentScheduleOrdinal: thisOrdinal,
					arrOrdinalNumbers: arrOrdinalNumbers,
					disableScheduling: false,
				});
			});
		}
	}

    handleIsScheduled( isScheduledValue ) {
		const recordsState = this.props.recordsState;
        const recGeneral = recordsState.record.record;
		/* TODO: consider whether we need the async/await for these.  I suspect we can just call them normally and let them run in the background. */
		if ( isScheduledValue ) {
			(async () => {
				await this.props.recordsDispatch.updateRecordIsScheduled(recGeneral.id, isScheduledValue );
			})().then(() => {
			});
		} else {
			(async () => {
				await this.props.recordsDispatch.updateRecordIsScheduled(recGeneral.id, isScheduledValue );
				await this.props.recordsDispatch.updateRecordScheduleOrdinal(recGeneral.id, null);
			})().then(() => {
			});
		}

		this.setState({ isScheduled: isScheduledValue });
    }

    handleIsSymptomatic(isSymptomatic) {
        const recGeneral = this.props.recordsState.record.record;
        recGeneral.isSymptomatic = isSymptomatic;
        this.props.recordsDispatch.updateRecordIsSymptomatic(recGeneral.id, isSymptomatic);
    }

	adjustVisibiltyOfQuestions() {
		const record = this.props.recordsState.record;
		if ( record === null || record === undefined ) {
			return;
		}
		const recGeneral = record.record;
		if ( recGeneral === null || recGeneral === undefined ) {
			return;
		}

		this.setState({ showAfibChildren: recGeneral.hasAfib });
		if ( ! recGeneral.hasAfib ) {
			/* event children */
			record.hasAfib30 = null;
			/* holter children */
			record.afibLongestDuration = null;
			/* 12-lead children */
			record.hasAfibContinuous = null;
		}

		this.setState({ showAflutterChildren: recGeneral.hasAflutter });
		if ( ! recGeneral.hasAflutter ) {
			/* event children */
			record.hasAflutter30 = null;
			/* holter children */
			record.aflutterLongestDuration = null;
			/* 12-lead children */
			record.hasAflutterContinuous = null;
		}

		this.setState({ showAtachyChildren: recGeneral.hasAtachy });
		if ( ! recGeneral.hasAtachy ) {
			/* event children */
			record.hasAtachy30 = null;
			/* holter children */
			record.atachyLongestDuration = null;
			/* 12-lead children */
			record.hasAtachyContinuous = null;
		}

		this.props.recordsDispatch.set(record);
	}

    handleYesNo(type,isTrue) {
        const record = this.props.recordsState.record;
        const recGeneral = record.record;

		switch ( type ) {

			case viewRecordType.isMdNotification:
			case viewRecordType.isAnalyzable:
				recGeneral[type] = isTrue;
				break;

			case viewRecordType.hasAfib:
				this.setState({ showAfibChildren: isTrue });
				recGeneral[type] = isTrue;
				break;
			case viewRecordType.hasAflutter:
				this.setState({ showAflutterChildren: isTrue });
				recGeneral[type] = isTrue;
				break;
			case viewRecordType.hasAtachy:
				this.setState({ showAtachyChildren: isTrue });
				recGeneral[type] = isTrue;
				break;

			case viewRecordType.hasAfib30:
			case viewRecordType.hasAflutter30:
			case viewRecordType.hasAtachy30:
			case viewRecordType.hasAfibContinuous:
			case viewRecordType.hasAflutterContinuous:
			case viewRecordType.hasAtachyContinuous:
				record[type] = isTrue;
				break;

			default:
				break;
		}

		this.adjustVisibiltyOfQuestions();
		this.props.recordsDispatch.set(record);
		this.setState({ dataNeedsSaving: true });
    }

	handleDropdownOrdinalNumber( theChoices ) {
		let theChoice = theChoices[0];
		this.setState({ currentScheduleOrdinal: theChoice });
        const recGeneral = this.props.recordsState.record.record;
		const serviceType = recGeneral.serviceType;

		const allStudies = this.props.accountsState && this.props.accountsState.authenticatedAccount && this.props.accountsState.authenticatedAccount.studies;
		if (allStudies) {
			const thisStudyId = this.state.studyId;
			const study = allStudies.find(function (s) { return s.id === thisStudyId });
			if (study) {
				let allCompSchedules = study.allCompSchedules;
				if (allCompSchedules) {
					if (typeof allCompSchedules === 'string' || allCompSchedules instanceof String) {
						allCompSchedules = JSON.parse(allCompSchedules);
					}
					this.setState({ currentSchedulePeriod: allCompSchedules[serviceType] });
					recGeneral.schedulePeriod = allCompSchedules[serviceType];
				}
			}
		}

		this.props.recordsDispatch.updateRecordScheduleOrdinal(recGeneral.id, String(theChoice).replace(blankDropdown, ''), recGeneral.schedulePeriod);
	}

	handleDropdownSuffix( theChoices ) {
		let theChoice = theChoices[0];
		this.setState({ currentScheduleSuffix: theChoice });
        const recGeneral = this.props.recordsState.record.record;
		this.props.recordsDispatch.updateRecordScheduleSuffix(recGeneral.id, String(theChoice).replace(blankDropdown,''));
	}

    handleValue(value, type) {
        const record = this.props.recordsState.record;
        const recGeneral = record.record;
        var updateMdOverreadFindings = false;

        switch (type) {
            case viewRecordType.predominantRhythm:
                recGeneral[type] = value[0];
				break;

			case viewRecordType.afibLongestDuration:
			case viewRecordType.aflutterLongestDuration:
			case viewRecordType.atachyLongestDuration:
			case viewRecordType.analyzableDuration:
			case viewRecordType.totalDuration:
				if ( /^(\d\d*):([0-5]\d*)(:[0-5]\d*)?$/.test(value) ) {
					record[type] = value;
				} else {
					record[type] = value;
				}
				break;


            case viewRecordType.comments:
                recGeneral.comments = value;
				break;
            case viewRecordType.deviceModel:
                recGeneral.deviceModel = value;
                break;
            case viewRecordType.deviceSerial:
                recGeneral.deviceSerial = value;
                break;
            case viewRecordType.mdRejectionReason:
                recGeneral.mdRejectionReason = value;
                break;
            case viewRecordType.mdOverreadFindings:
                recGeneral.mdOverreadFindings = value;
                updateMdOverreadFindings = true;
                break;


            case viewRecordType.receiveDateTime:
				// console.log(`handlevalue(${type}, ${value})  `);
				{
				let tzOffset = this.state.timeZoneOffsetMinutes;
				if ( Math.abs(tzOffset) <= 16 ) {
					tzOffset *= 60;
				}
				recGeneral.receiveDateTime = moment(value).subtract(tzOffset,'m').format("YYYY-MM-DDTHH:mm:ss");
				}
				break;

            case viewRecordType.recordDateTime:
				// console.log(`handlevalue(${type}, ${value})  `);
				{
				let tzOffset = this.state.timeZoneOffsetMinutes;
				if ( Math.abs(tzOffset) <= 16 ) {
					tzOffset *= 60;
				}
				recGeneral.recordDateTime = moment(value).subtract(tzOffset,'m').format("YYYY-MM-DDTHH:mm:ss");
				}
				break;

            case viewRecordType.timeZoneOffsetMinutes:
				if ( ! /^-?\d*$/.test(value) ) {
					break;
				}
				let tzOffset = value;
				if ( Math.abs(tzOffset) <= 16 ) {
					tzOffset *= 60;
				}
				this.setState({
					timeZoneOffsetMinutes: value,
				});
                recGeneral.timeZoneOffsetMinutes = value;
                break;

            default:
                break;
        }

        (async () => {
            await this.props.recordsDispatch.set(record);
        })().then(() => {
            if (!updateMdOverreadFindings) {
                this.setState({
                    dataNeedsSaving: true
                });
            }
        });
    }

	getReportDiv(report) {
		// Internet Explorer 6-11
		var isIE = /*@cc_on!@*/false || !!document.documentMode;

		if ( isIE ) {
			if ( report !== null ) {
				if ( ! this.pdfLoading ) {

					this.pdfLoading = true;

					// Loaded via <script> tag, create shortcut to access PDF.js exports.
					var pdfjsLib = window['pdfjs-dist/build/pdf'];

					// The workerSrc property shall be specified.  This is a 3rd party PDF viewer from Mozilla that works with IE browsers.
					pdfjsLib.GlobalWorkerOptions.workerSrc = '//mozilla.github.io/pdf.js/es5/build/pdf.worker.js';

					var parentThis = this;

					// Using DocumentInitParameters object to load binary data.
					var loadingTask = pdfjsLib.getDocument({url: report});
					loadingTask.promise.then(function(pdf) {
					  
						var viewer = document.getElementById('pdf-viewer');

						for ( var pageNumber = 1; pageNumber <= pdf.numPages ; pageNumber++) {

						  let canvas = document.createElement("canvas");    
						  canvas.className = 'pdf-page-canvas';         
						  viewer.appendChild(canvas);            

						  // Fetch the first page
						  pdf.getPage(pageNumber).then(function(page) {
							var scale = 1.5;
							let viewport = page.getViewport({scale: scale});

							// Prepare canvas using PDF page dimensions

							// let canvas = document.getElementById('the-canvas');
							let context = canvas.getContext('2d');
							canvas.height = viewport.height;
							canvas.width = viewport.width;

							// Render PDF page into canvas context
							let renderTask = page.render({ canvasContext: context, viewport: viewport });
							renderTask.promise.then(function () {
							});
						  });
						}
					}, function (reason) {
					  // PDF loading error
					  parentThis.pdfLoading = false;
					});
				}
			}

			return <div id='pdf-viewer'></div>;
		} else {
			return <object className="pdf-viewer" data={report} type="application/pdf"> PDF Report </object>;
		}
	}

	hasYesOrNoAnswer( idName ) {
		let elYes = document.getElementById( idName + '_Yes');
		let elNo = document.getElementById( idName + '_No');

		return (elYes && elYes.checked) || (elNo && elNo.checked);
	}

    render() {
        const accountsState = this.props.accountsState;
        if (!Accounts.authenticatedAllRoles(accountsState)) {
            return (
                <NotAuthenticated />
            );
        }

        const authenticatedRole = accountsState.authenticatedAccount.role;
        var error = false;
        const fetching = this.props.recordsState.fetching;
		const isAdministratorRole = authenticatedRole === Accounts.accountRoles.Administrator;
		const isPmRole = authenticatedRole === Accounts.accountRoles.Pm;
		const isQaRole = authenticatedRole === Accounts.accountRoles.Qa;
        const isPhysicianRole = authenticatedRole === Accounts.accountRoles.Physician;
        const isHcsRole = Accounts.isHcsRole(authenticatedRole);
        var isEvent = false;
        var isHolter = false;
		var is12Lead = false;
		let isInitial = false;
        var message = "";
        var metadataDiv = null;
		var overreadDiv = null;
		var disableUploadReport = true;
		let isDisplayRejectionReason = false;
		var record = this.props.recordsState.record;
		let mayEditCrf = false;
		let reasonsWhyQaDisabled = [];
        var report = null;
        var serviceTypeDisabled = true;
        var uploadDiv = null;
		var serviceType = null;
		var patientCode = null;
		var siteName = null;
		var studyName = null;
		var erk = null;
		let disableQa = true;
		let disableQaControl = true;
		let disableAll = true;
		let disableQaRequired = true;
		let disableMdOverreadAssigned = true;

/*
 *
 * OLD SPEC:
 *
 * In general, nothing is editable on events; holter and 12-lead are editable until QA is marked yes.
 *
 * To expand on what Mike said - admins and techs can both create
 * 12-lead/holter records for patients and edit everything until it's "needMD"
 * status, then everything should be locked for them until it returns from
 * overread (needsQA), when only the admin is able to make corrections and mark QA.
 *
 * Physicians should be able to edit overread and rejection (admin/tech can't),
 * and measurement data; otherwise everything else should be locked.
 *
 * Study managers and site coordinators are read-only.
 *
 * Physicians, study managers, and site coordinators should be able to view
 * everything except for "Is MD overread required" and "Is QA required" sections.
 *
 * Note: for measurements, physicians can't correct events -- pretty much
 * everything on an event is read only. if we allow edits, the datapuller will
 * see something as a change and update it back to what is in dynavision.
 *
 * Physician rejection shouldn't be visible to study manager and site coordinator roles.
 *
 * Patient ECG history table is only visible to the physician.
 *
*/

/*
export const recordStatus = {
    initial: 0,
    rejectedByMd: 5,
    needsOverread: 10,
    needsQa: 20,
    final: 30
}
*/


        if (record != null && record.record != null && record.record.patient != null) {
            const recGeneral = record.record;
            serviceType = recGeneral.serviceType;

			patientCode = recGeneral.patient.code;
			siteName = recGeneral.patient.studySite.site.name;
			studyName = recGeneral.patient.studySite.study.name;
			erk = record.erk;

            isEvent = serviceType === Records.recordServiceTypes.event;
            isHolter = serviceType === Records.recordServiceTypes.holter;
			is12Lead = serviceType === Records.recordServiceTypes.twelveLead;
			report = this.props.recordsState.report;

			disableMdOverreadAssigned = (
				!recGeneral.isMdOverreadRequired ||
				recGeneral.isMdOverreadComplete ||
				! isHcsRole
			);

			disableQaRequired = (
				recGeneral.isQaComplete ||
				!isAdministratorRole ||
				!isPmRole ||
				!isQaRole

			);

			switch (recGeneral.status) {
				case Records.recordStatus.initial:	/* 0 */
					isInitial = true;
					if (isHcsRole) {
						disableAll = false;
						mayEditCrf = true;
						disableUploadReport = false;
						serviceTypeDisabled = false;
						disableMdOverreadAssigned = false;
					}
					disableQa = true;
					reasonsWhyQaDisabled.push("Not yet sent to the physician");
					break;
				case Records.recordStatus.rejectedByMd:	/* 5 */
					isDisplayRejectionReason = true;
					if (isHcsRole) {
						mayEditCrf = true;
						disableAll = false;
						disableUploadReport = false;
						serviceTypeDisabled = false;
					}
					disableQa = true;
					reasonsWhyQaDisabled.push("Rejected by the physician and new report not uploaded yet.");
					break;
				case Records.recordStatus.needsOverread:	/* 10 */
					if (isAdministratorRole) {
						disableAll = false;
						mayEditCrf = true;
						disableUploadReport = false;
						serviceTypeDisabled = false;
					} else {
						disableAll = true;
						serviceTypeDisabled = true;
					}
					disableQa = true;
					reasonsWhyQaDisabled.push("Still requires overread of physician.");
					break;
				case Records.recordStatus.needsQa:	/* 20 */
					if (isAdministratorRole) {
						disableAll = false;
						mayEditCrf = true;
						disableUploadReport = false;
						serviceTypeDisabled = false;
						disableQa = false;
					} else if (isQaRole || isPmRole) {
						disableQa = false;
                    } else {
						disableAll = true;
						serviceTypeDisabled = true;
						disableQa = true;
						reasonsWhyQaDisabled.push("Only Administrator, PM or QA can change QA/Complete status");
					}
					break;
				case Records.recordStatus.final:	/* 30 */
					disableAll = true;
					disableMdOverreadAssigned = true;
					serviceTypeDisabled = true;
					if (isAdministratorRole || isPmRole || isQaRole) {
						disableQa = false;
						disableQaControl = false;
					} else {
						disableQa = true;
						reasonsWhyQaDisabled.push("Only Administrator, PM or QA can change QA/Complete status");
					}
					break;
				default:
					break;
			}

			if ( ! (recGeneral.deviceSerial && (recGeneral.deviceSerial.length > 0)) ) {
				disableQa = true;
				reasonsWhyQaDisabled.push("Device serial needs to be populated");
			}
			if ( (this.state.isScheduled === null) || (this.state.isScheduled === "undefined") || (this.state.isScheduled && ! /^\d.*/.test(this.state.currentScheduleOrdinal)) ) {
				disableQa = true;
				reasonsWhyQaDisabled.push("Scheduled needs to be answered and completed");
			}
			if ( ! this.hasYesOrNoAnswer('symptomaticRadio') ) {
				disableQa = true;
				reasonsWhyQaDisabled.push("Symptomatic must be answered");
			}
			if ( recGeneral.isAnalyzable !== true ) {
				disableQa = true;
				reasonsWhyQaDisabled.push("Analyzable has to be yes");
			}
			if ( ! recGeneral.predominantRhythm || recGeneral.predominantRhythm.length === 0 || recGeneral.predominantRhythm === viewRecordType.unknown ) {
				disableQa = true;
				reasonsWhyQaDisabled.push("Predominant rhythm must be selected");
			}
			if ( (recGeneral.hasAfib === "undefined") || (recGeneral.hasAflutter === "undefined") || (recGeneral.hasAtachy === "undefined") ) {
				disableQa = true;
				reasonsWhyQaDisabled.push("All Afib/Aflutter/ATachy questions must be answered");
			}
			if ((recGeneral.predominantRhythm === 'Atrial Fibrillation' && ! recGeneral.hasAfib) ||
				(recGeneral.predominantRhythm === 'Atrial Flutter' && ! recGeneral.hasAflutter) ||
				(recGeneral.predominantRhythm === 'Atrial Tachycardia' && ! recGeneral.hasAtachy)
			) {
				disableQa = true;
				reasonsWhyQaDisabled.push("If Predominant rhythm is afib or aflutter or atachy, yes needs to be selected in the corresponding radio");
			}

			/* Event specific */
			if ( isEvent ) {
				if (
						(recGeneral.hasAfib && (record.hasAfib30 === "undefined")) ||
						(recGeneral.hasAflutter && (record.hasAflutter30 === "undefined")) ||
						(recGeneral.hasAtachy && (record.hasAtachy30 === "undefined"))
				   )
				{
					disableQa = true;
					reasonsWhyQaDisabled.push("The 30 second questions need to be answered if their parent is yes");
				}
			}

			/* Holter specific*/
			if ( isHolter ) {
				let momTotalDuration = moment(record.totalDuration,"hh:mm");
				let momAnalyzableDuration = moment(record.analyzableDuration,"hh:mm");
				let momAfibLongestDuration = moment(record.afibLongestDuration,"hh:mm:ss");
				let momAflutterLongestDuration = moment(record.aflutterLongestDuration,"hh:mm:ss");
				let momAtachyLongestDuration = moment(record.atachyLongestDuration,"hh:mm:ss");

				if (!record.totalDuration) {
					disableQa = true;
					reasonsWhyQaDisabled.push("The total duration needs to be populated");
				}
				if ( !record.analyzableDuration) {
					disableQa = true;
					reasonsWhyQaDisabled.push("The analyzable duration needs to be populated");
				}
				if (   (recGeneral.hasAfib && !record.afibLongestDuration)
						|| (recGeneral.hasAflutter && !record.aflutterLongestDuration)
						|| (recGeneral.hasAtachy && !record.atachyLongestDuration)
				   ) {
					disableQa = true;
					reasonsWhyQaDisabled.push("The longest duration questions need to be populated if their parent is yes");
				}
				if ( momTotalDuration.diff(momAnalyzableDuration,'seconds') < 0 ) {
					disableQa = true;
					reasonsWhyQaDisabled.push("The analyzable duration can't be > total duration");
				}
				if ( (momAfibLongestDuration.diff(momAnalyzableDuration,'seconds') > 0)
						|| (momAtachyLongestDuration.diff(momAnalyzableDuration,'seconds') > 0)
						|| (momAflutterLongestDuration.diff(momAnalyzableDuration,'seconds') > 0)
				   ) {
					disableQa = true;
					reasonsWhyQaDisabled.push("The longest durations can't be > analyzable duration");
				}
			}

			if ( recGeneral.isMdNotification === null || recGeneral.isMdNotification === "undefined" ) {
				disableQa = true;
				reasonsWhyQaDisabled.push("MD notification needs to be answered");
			}

			if ( this.isCrfUnanswered() ) {
				disableQa = true;
				reasonsWhyQaDisabled.push("If CRF questions, they need to be answered as well");
			}

			switch ( authenticatedRole ) {
				case Accounts.accountRoles.Administrator:
				case Accounts.accountRoles.Pm:
				case Accounts.accountRoles.Qa:
				case Accounts.accountRoles.Technician:
					break;
				case Accounts.accountRoles.Physician:
					serviceTypeDisabled = true;
					break;
				case Accounts.accountRoles.StudyManager:
				case Accounts.accountRoles.SiteCoordinator:
				case Accounts.accountRoles.Guest:
					disableAll = true;
					isDisplayRejectionReason = false;
					break;
				default:
					break;
			}

            if (report == null) {
                if (fetching) {
                    message = "Loading report..."
                }
                else {
                    message = "A report does not exist for this record.";
                }
            }

			metadataDiv = this.getMetadataDiv( recGeneral, disableAll || isEvent);
            overreadDiv = this.getOverreadDiv( recGeneral, isPhysicianRole);
			uploadDiv = this.getUploadDiv( isAdministratorRole, isHcsRole, disableUploadReport, recGeneral.isMdOverreadComplete, recGeneral.isQaComplete);

        }
        else if (fetching) {
            message = "Loading record..."
        }
        else {
            error = true;
            message = "Error retrieving record.";
        }

        const alertColor = error ? "danger" : "primary";
        const displayMessage = message !== "";
        const displayNoRecordMessage = (
            displayMessage &&
            record == null
        );
        const displayReport = report != null;
        const displayUpload = (
            !displayReport ||
			isHcsRole
        );

		const objPdf = this.getReportDiv(report);

		const RecordHeader = () => {
			const theStatus = () => {
				if ( /localhost/.test(window.location.href) ) {
					return this.props.recordsState.record.record.status;
				} else {
					return "";
				}
			};
			return (
					<div className="gap-bottom">
						<div id="hidden-status"> { theStatus() } </div>
						<h1> Record </h1>
						<div> Service Type: <span className="bold"> {serviceType} </span> </div>
						<div> Patient Code: <span className="bold"> {patientCode} </span> </div>
						<div> Site: <span className="bold"> {siteName} </span> </div>
						<div> Study: <span className="bold"> {studyName} </span> </div>
						<div> ERK: <span className="bold"> {erk} </span> </div>
					</div>
				   );
		};

        const save = "Save";

        return (
            <div className="gap" id={viewRecordId}>
                {displayNoRecordMessage
                    ?
                    <Alert color={alertColor}>
                        {message}
                    </Alert>
                    :
                    <div>
						<RecordHeader />
						<div style={{ padding: 10}} className={this.state.dataNeedsSaving ? "needs-saving" : null}>
							{metadataDiv}
							<hr />
							<this.IsScheduledDiv recordRecord={record.record} disabled={disableAll || isPhysicianRole} />
							<this.IsSymptomaticDiv recordRecord={record.record} disabled={disableAll} />
							<this.IsAnalyzable isAnalyzable={record.record.isAnalyzable} disabled={disableAll} />
							<this.PredominantRhythm disabled={disableAll} />
							<this.RecordQuestions disabled={disableAll || ! record.record.isAnalyzable} record={record} serviceType={serviceType} />
							<this.OverreadRelatedDiv
								hidden={!isHcsRole}
								recordRecord={record.record}
								displayRejectionReason={isDisplayRejectionReason}
								disableMdOverreadAssigned={disableMdOverreadAssigned}
								disableMdOverreadRequired={disableAll || ! isInitial}
								disableQaRequired={disableQaRequired}
								disableQa={disableQa}
								disableQaControl={disableQaControl}
								reasonsWhyQaDisabled={reasonsWhyQaDisabled}
							/>

							{this.state.dataNeedsSaving && (
								<div className="gap needs-saving">
									<Button className="button" onClick={this.handleSave} title={save}>{save}</Button>{' '}
									<div className="button-gap" />
								</div>
							)}
						</div>
						<div className="gap" />

                        {isEvent && <CreateRecordCrfQa studyId={this.props.studyId} disabled={!mayEditCrf} saveButton handleCrfQnA={this.handleCrfQnA} serviceType={Records.recordServiceTypes.event} />}
                        {isHolter && <CreateRecordCrfQa studyId={this.props.studyId} disabled={!mayEditCrf} saveButton handleCrfQnA={this.handleCrfQnA} serviceType={Records.recordServiceTypes.holter} />}
                        {is12Lead && <CreateRecordCrfQa studyId={this.props.studyId} disabled={!mayEditCrf} saveButton handleCrfQnA={this.handleCrfQnA} serviceType={Records.recordServiceTypes.twelveLead} />}
                        <div className="gap">
                            {displayMessage && <Alert color={alertColor}>{message}</Alert>}
                            {displayUpload && uploadDiv}
                        </div>
                        {displayReport &&
                            <div className="gap">
								{objPdf}
                            </div>
                        }
                        {isEvent && <CreateRecordEvent disabled={serviceTypeDisabled} saveButton />}
                        {isHolter && <CreateRecordHolter disabled={serviceTypeDisabled} saveButton />}
                        {is12Lead && <CreateRecord12Lead disabled={serviceTypeDisabled} saveButton />}
						<this.DisplayPatientRecordHistory show={isPhysicianRole || isHcsRole} />
                        {overreadDiv}
						<Button className="button gap" onClick={this.backToSelectRecords}> Back </Button>
                    </div>
                }
            </div>
        );
    }

    upload(inputId) {
        var file = null;
        const input = document.getElementById(inputId);
        if (input != null &&
            input.files != null &&
            input.files.length === 1) {
            file = input.files[0];
        }

		const recordId = this.props.recordsState.record.record.id;

        if (file != null) {
            (async () => {
				this.setState({ lastFetchedRecordId: null });	/* prepare to refresh the pdf report */
                await this.props.recordsDispatch.uploadReport(file, recordId);
            })().then(() => {
                this.initialize(null);
				this.setState({ lastFetchedRecordId: recordId });	/* refresh the pdf report */
            });
        }
        input.value = null;
    }
}

export default withRouter(connect(
    state => ({
        accountsState: state.accounts,
        recordsState: state.records,
        localizerState: state.localizer
    }),
    dispatch => ({
        accountsDispatch: bindActionCreators(Accounts.actionCreators, dispatch),
        recordsDispatch: bindActionCreators(Records.actionCreators, dispatch)
    })
)(ViewRecord));



// WEBPACK FOOTER //
// ./src/components/ViewRecord.js